import { MenuPoint } from '@agilox/ui-common';
import { selfTestMenuPoints } from './menupoints';

export const desktopMenupoints: MenuPoint[] = [selfTestMenuPoints.tests, selfTestMenuPoints.logout];
